export default __webpack_public_path__ + "static/media/PrizeMultiplier_159x150.d519ec94.png";